module.exports = __webpack_public_path__ + "static/media/SC_UT_07.6b40afa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/shirt/SC_UT_07.png
// module id = 120
// module chunks = 0